const MODAL_SELECTOR = ".general-modal-bg";
const HIDDEN_CLASS = "general-modal-bg--hidden";

export const showModal = (): void => {
    const modal = document.querySelector<HTMLElement>(MODAL_SELECTOR);
    modal?.classList.remove(HIDDEN_CLASS);
};

export const setupModalListeners = (onClose?: () => void) => {
    const backdrop = document.querySelector<HTMLElement>(MODAL_SELECTOR);
    if (!backdrop) return;

    const handleBackdropClick = (e: MouseEvent) => {
        if (e.target === backdrop) handleClose();
    };

    const handleClose = () => {
        backdrop.classList.add(HIDDEN_CLASS);
        onClose?.();

        backdrop.removeEventListener("click", handleBackdropClick);
        window.removeEventListener("keydown", handleEscape);
    };

    const handleEscape = (event: KeyboardEvent) => {
        if (event.key === "Escape") handleClose();
    };

    backdrop.addEventListener("click", handleBackdropClick, { once: true });

    window.addEventListener("keydown", handleEscape);
};